import { graphql } from '@api/mesa'

const GET_RECURRING_SCHEDULED_PAYMENTS = graphql(`
  query getRecurringScheduledPayment {
    getRecurringScheduledPayment {
      transferAmountStrategy
      nextScheduledTransferDate
      transferSourceAccount {
        id
        last4
        bankName
        accountName
        accountSubtype
      }
      schedulePaymentId
    }
  }
`)

export const CardPaymentsGqlQueries = {
  GET_RECURRING_SCHEDULED_PAYMENTS,
}
